/**
 * PointerLockManager: requests/exits pointer lock and reports its state.
 * Adapted from supersplat-viewer/src/input/app/pointer-lock.ts (simplified).
 */

class PointerLockManager {
    private _canvas: HTMLCanvasElement;
    private _locked = false;
    onChange: ((locked: boolean) => void) | null = null;

    constructor(canvas: HTMLCanvasElement) {
        this._canvas = canvas;
        document.addEventListener('pointerlockchange', this._onPointerLockChange);
        document.addEventListener('pointerlockerror', this._onPointerLockError);
    }

    get locked(): boolean {
        return this._locked;
    }

    request(): void {
        if (document.pointerLockElement !== this._canvas) {
            this._canvas.requestPointerLock();
        }
    }

    exit(): void {
        if (document.pointerLockElement === this._canvas) {
            document.exitPointerLock();
        }
    }

    private _onPointerLockChange = () => {
        this._locked = document.pointerLockElement === this._canvas;
        this._canvas.classList.toggle('pointer-locked', this._locked);
        this.onChange?.(this._locked);
    };

    private _onPointerLockError = () => {
        this._locked = false;
    };
}

export { PointerLockManager };
